<template>
  <div class="dataTable__heading">
    <button
      v-for="column in Object.entries(columns)"
      :key="column[0]"
      :class="
        'dataTable__cell d-flex justify-content-between align-items-center ' +
        (column[1].sortable ? 'dataTable__sortable ' : '')
      "
      @click="sort(column[1], column[0])"
    >
      <span>{{ stringManager().capitalize(column[1].title) }}</span>
      <FontAwesomeIcon
        v-if="column[1].sortable"
        :icon="'fa-light ' + (column[1].sortWay ? 'fa-sort-' + column[1].sortWay : 'fa-sort')"
      />
    </button>
  </div>
</template>

<script>
import { stringManager } from "@/services/utilities/string-manager";

export default {
  name: "HeadingDataTableComponent",
  components: {},
  props: {
    columns: {
      type: Object,
      required: true,
    },
  },
  emits: ["sort"],
  methods: {
    stringManager() {
      return stringManager;
    },
    sort(column, columnName) {
      this.$emit("sort", column, columnName);
    },
  },
};
</script>

<style lang="scss" scoped>
.dataTable {
  &__cell {
    border: none;
    background: inherit;
    color: var(--primary-color);
    font-weight: 700;
    cursor: default;
    text-align: start;

    @include dark-theme {
      color: $white;
    }
  }
  &__sortable {
    cursor: pointer;
  }
}
</style>
